import { useCallback, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import {
  dismissToast,
  getToastsSnapshot,
  subscribeToasts,
} from "@/components/ui/toast/toastStore";
import { ToastItem } from "@/components/ui/toast/ToastItem";

/**
 * Globaler Toast-Container. Wird einmal im App-Root gerendert und zeigt alle
 * über das `toast`-API (`@/lib/toast`) ausgelösten Benachrichtigungen an.
 */
export function ToastViewport() {
  const toasts = useSyncExternalStore(subscribeToasts, getToastsSnapshot, getToastsSnapshot);
  const handleDismiss = useCallback((id: string) => dismissToast(id), []);

  if (typeof document === "undefined") return null;

  return createPortal(
    <div
      className="eh-toast-viewport pointer-events-none fixed inset-x-0 top-0 z-[2000] flex flex-col items-center gap-2 px-3 pt-[max(0.75rem,env(safe-area-inset-top))] sm:inset-x-auto sm:right-4 sm:items-end"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="w-full max-w-sm">
          <ToastItem toast={toast} onDismiss={handleDismiss} />
        </div>
      ))}
    </div>,
    document.body,
  );
}
